import { render, staticRenderFns } from "./baseTable3.vue?vue&type=template&id=0b6c18ce"
import script from "./baseTable3.vue?vue&type=script&lang=js"
export * from "./baseTable3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports